import moment from "moment";
import { Component } from "react";


export default class PersonaJuridica extends Component {


    render() {

        let datos = this.props.PersonaJuridica;
        return (
            <div>


                <div className="card shadow mb-4">
                    <div className="card-header">
                        <h6 className="m-0 font-weight-bold text-primary">Datos de la {datos.identificacionPrincipal.tipoPersona.nombre}</h6>
                    </div>
                    <div className="card-body text-gray-800">
                    <div className="form-row">
                            <div className="form-group col-md-6">
                                <label htmlFor="identificacion" id="lblIdentificacion" className="col-form-label">Identificación</label>
                                <input type="text" name="identificacion" id="identificacion" value={datos.identificacionPrincipal.codigo} className="form-control" readOnly />
                                <input type="hidden" name="HiddenIdentificacion" id="HiddenIdentificacion" value={datos.identificacionPrincipal.codigo} readOnly />
                            </div>
                            <div className="form-group  col-md-6">
                                <label htmlFor="tipoPersona" className="col-form-label">Tipo Persona </label>
                                <input type="text" name="tipoPersona" id="tipoPersona" value={datos.identificacionPrincipal.tipoPersona.nombre} className="form-control" readOnly />
                                <input type="hidden" name="HiddenClasePersona" id="HiddenClasePersona" value={datos.identificacionPrincipal.tipoPersona.clase} readOnly />
                                <input type="hidden" name="HiddenIdPersona" id="HiddenIdPersona" value={datos.identificacionPrincipal.tipoPersona.codigo} readOnly />

                            </div>
                        </div>
                        <div className="form-row">
                            <div className="col-md-12">
                                <label id="lblNombreORazonSocial" htmlFor="RazonSocial" className="col-form-label">Razón Social</label>
                                <input type="text" name="RazonSocial" id="RazonSocial" value={datos.nombreORazonSocial} className="form-control" readOnly />
                            </div>
                        </div>
                        <div className="form-row">
                            <div className="col-md-6">
                                <label id="lblPaisNacimiento" htmlFor="paisRegistro" className="col-form-label">País Registro</label>
                                <input type="text" name="paisRegistro" id="paisRegistro" value={datos.paisRegistroONacimiento?.nombrePais} className="form-control" readOnly />
                            </div>

                            <div className="col-md-6">
                                <label id="lblFechaNacimiento" htmlFor="FechaConstitucion" className="col-form-label">Fecha Constitución</label>
                              
                            <input type="text" name="FechaConstitucion" id="FechaConstitucion" value={datos.fechaConstitucionONacimiento == null?"":moment(datos.fechaConstitucionONacimiento).format("DD/MM/YYYY")} className="form-control" readOnly />   
                         
                                </div>
                        </div>

                    </div>
                </div>

            {/* <div>
                { datos.representanteLegal === null ? null :
                 (
                    <div className="card shadow mb-4">
                        <div className="card-header">
                            <h6 className="m-0 font-weight-bold text-primary">Datos del Representante Legal</h6>
                        </div>
                        <div className="card-body text-gray-800">
                            <div className="form-row">
                                <div className="form-group col-md-6">
                                    <label id="lblIdentificacion" htmlFor="identificacionRepresentanteLegal" className="col-form-label">Identificación</label>
                                    <input type="text" name="identificacion" id="identificacionRepresentanteLegal" value={persona.identificacionPrincipal.codigo} className="form-control" readOnly />
                                    <input type="hidden" name="HiddenIdentificacionRepLegal" id="HiddenIdentificacionRepLegal" value={persona.identificacionPrincipal.codigo} readOnly />
                                </div>
                                <div className="form-group col-md-6">
                                    <label id="lblTipoPersona" htmlFor="tipoPersonaRepresentanteLegal" className="col-form-label">Tipo Persona</label>
                                    <input type="text" name="tipoPersona" id="tipoPersonaRepresentanteLegal" value={persona.identificacionPrincipal.tipoPersona.nombre} className="form-control" readOnly />
                                    <input type="hidden" name="HiddenTipoPersonaRepLegal" id="HiddenTipoPersonaRepLegal" value={persona.identificacionPrincipal.tipoPersona.codigo} readOnly />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group col-md-4">
                                    <label id="lblNombreORazonSocial" htmlFor="nombrePersonaFisica" className="col-form-label">Nombre</label>
                                    <input type="text" name="nombrePersonaFisica" id="nombrePersonaFisica" value={persona.nombre} className="form-control" readOnly />
                                </div>
                                <div className="form-group col-md-4">
                                    <label id="lblPrimerApellido" htmlFor="primerApellido" className="col-form-label">Primer Apellido</label>
                                    <input type="text" name="primerApellido" id="primerApellido" value={persona.primerApellido} className="form-control" readOnly />
                                </div>
                                <div className="form-group col-md-4">
                                    <label id="lblSegundoApellido" htmlFor="segundoApellido" className="col-form-label">Segundo Apellido</label>
                                    <input type="text" name="segundoApellido" id="segundoApellido" value={persona.segundoApellido??""} className="form-control" readOnly />
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="form-group col-md-6">
                                    <label id="lblPaisNacimiento" htmlFor="paisNacimiento" className="col-form-label">País Nacimiento</label>
                                    <input type="text" name="paisNacimiento" id="paisNacimiento" value={persona.paisNacimiento?.nombrePais} className="form-control" readOnly />
                                </div>
                                <div className="form-group col-md-6">
                                    <label id="lblFechaNacimiento" htmlFor="fechaNacimiento" className="col-form-label">Fecha Nacimiento</label>
                                    <input type="text" name="fechaNacimiento" id="fechaNacimiento" value={persona.fechaNacimiento != null? moment(persona.fechaNacimiento).format("DD/MM/YYYY"):""} className="form-control" readOnly />
                                </div>
                            </div>

                        </div>
                    </div>
                )
                }
                </div> */}





            </div>
        );
    }
}